export default __webpack_public_path__ + "static/media/photos.5e45dfa9.svg";